import React, { useState, useEffect } from "react";
import { Collapse, Button } from "antd";
import ProductItem from "./ProductItem";
import { PlusOutlined } from "@ant-design/icons";
import { v4 as uuidv4 } from 'uuid';

const ProductList = ({ bundle_products, setInnerProducts, form }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    
    
    if (bundle_products?.modifier_data && bundle_products.modifier_data.product_list) {
      const initializedProducts = [];

      // Now map through bc_secondary_sku
      const secondaryProducts = bundle_products.modifier_data.product_list.map((item) => {

        return {
          id: item.name,
          qty: item.qty,
          key: item.name,
          value: item.sku,
          name: item.name,
          store_id: bundle_products.store_id,
          editable: true,
          prod_id: 1
        };
      });
      initializedProducts.push(...secondaryProducts);


      setProducts(initializedProducts);
    }else{
       const initializedProducts = [];

      // Now map through bc_secondary_sku
      const secondaryProducts = bundle_products.bundle_sap_Array.map((item) => {

        return {
          id: item.prod_name,
          qty: item.qty,
          key: item.prod_name,
          value: item.sku,
          name: item.prod_name,
          store_id: bundle_products.store_id,
          editable: true,
          prod_id: item.prod_id
        };
      });
      initializedProducts.push(...secondaryProducts);


      setProducts(initializedProducts);
    }


  }, [bundle_products]);

  const addProduct = () => {
    const newId = uuidv4();
    const newProduct = {
      key: newId,
      id: newId,
      name: "New Product",
      editable: true,
      qty: 1,
      is_new: true,
      store_id: products[0]?.store_id || null
    };
    setProducts(prev => {
      const exists = prev.some(item => item.id === newId);

      if (exists) {
        return prev.map(item =>
          item.id === newId ? { ...item, ...newProduct } : item
        );
      } else {
        return [...prev, newProduct];
      }
    });

    setInnerProducts(products);
  };

  const removeProduct = (value) => {
    setProducts(products.filter((product) => product.value.trim() !== value.trim()));
    setInnerProducts(products.filter((product) => product.value.trim() !== value.trim()));

  };

  const updateProduct = (id, updatedFields) => {
    setProducts(products.map((product) =>
      product.id === id ? { ...product, ...updatedFields } : product
    ));

  };

  return (
    <Collapse
      defaultActiveKey={["products"]}
      items={[{
        key: "products",
        label: `Products (${products.length})`,
        children: (
          <>
            {products && products.length > 0 && products.map((product, index) => (
              <div key={product.id} style={{ marginBottom: "12px" }} className={`${product.prod_id == 0 ? 'ProductRed' : ''}`}>
                <ProductItem
                  products={products}
                  product={product}
                  onRemove={removeProduct}
                  onUpdate={updateProduct}
                  setInnerProducts={setInnerProducts}
                  form={form}
                  index={index}
                />
              </div>
            ))}
            {/* <Button onClick={addProduct} icon={<PlusOutlined />}> */}
            {/*   Add Product */}
            {/* </Button> */}
          </>
        )
      }]}
    />
  );
};

export default ProductList;
